module.exports = __webpack_public_path__ + "static/media/step-6-id.6dd82f09.jpg";